<template>

    <div class="p-top-none" :id="question.id">

      <div class="specialquestion-header">
        <div class="specialquestion-header-left">
          <div v-if="new Date(question.editable_until) > new Date()" >
            {{ $t('special_questions.place_bet_until_short') }} {{ question.editable_until | formatDateShort }}
          </div>
          <div v-else>
            <div v-if="this.solutions.length === 0">
              {{ $t('special_questions.place_bet_until') }}
            </div>
            <div>
              {{ $t('special_questions.points_won') }}
            </div>
          </div>
        </div>
        <div class="specialquestion-header-right">
          <div v-if="new Date(question.editable_until) > new Date()" >
              {{ questionTotalPoints }} {{ $t('points') }}
          </div>
          <div v-else>
            <div v-if="this.solutions.length === 0" style="text-align: right">
              {{ question.editable_until | formatDateShort }}
            </div>
            <div style="text-align: right">
              {{ pointsAchieved }}/{{ questionTotalPoints }} {{ $t('rankings_table_header_points') }}
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        
        <!--
        <div v-if="question.answer_count < 2" class="table-view-title" v-bind:class="{ question_answered: answerSaved }">
            {{ question.question }}
        </div>
        <div v-else class="table-view-title" v-bind:class="{ question_answered: answerSaved }">
            {{ question.question }} ({{question.answer_count}} {{ $t('special_questions.answers') }})
        </div>
        -->

        <div v-if="question.answer_count < 2" @click="questionClicked(question)" class="table-view-title" v-bind:class="{ question_answered: answerSaved }">
          {{ question.question }}
        </div>
        <div v-else class="table-view-title" @click="questionClicked(question)" v-bind:class="{ question_answered: answerSaved }">
          {{ question.question }} ({{question.answer_count}} {{ $t('special_questions.answers') }})
        </div>
        
        <div v-if="this.parseMatchdate(this.question.editable_until) > Date.now()" @click="questionClicked(question)">
    
            <!--
            <multiselect :disabled="!isEditable" @input="multiChanged" v-if="question.answer_count === 1 && question.type === 'TEAM'" v-model="values" :options="options" :multiple="true" :max="question.answer_count" :show-labels="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('please_select')" label="name" track-by="id" :preselect-first="false">
            </multiselect>
            -->
            
            <div v-if="question.answer_count > 0 && question.type === 'TEAM'" class="selectiongroup">
    
              <div v-if="!isTournament() || groupCount < 2" class="selectiongroup__item">
                <div v-for="team in options" class="input-checkbox">
                  <input type="checkbox" :id="question.id + '_' + team.id" @change="teamChecked($event)" :checked="isTeamSelected(team.id)" />
                  <label :for="question.id + '_' + team.id">
                    <div class="team-logo">
                      <img v-if="teamCode(team.id) && teamCode(team.id).length > 6" :src="teamLogo(team.id)">
                      <flag v-else-if="teamCode(team.id) && teamCode(team.id).length <= 6" :iso="teamCode(team.id)" />
                      <svg v-else width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M16.6788228,14.4666528 C16.6784319,14.5535821 16.6782365,14.6380312 16.6782365,14.72 C16.6782365,17.92 17.0754204,17.92 17.0754204,22 L6.90751142,22 C6.90751142,18 7.30469536,18 7.30469536,14.72 C7.30469536,14.5820958 7.30416879,14.4377219 7.30311564,14.2868783 C7.16189664,12.9183228 6.95059177,11.7026967 6.66920105,10.64 L6.38887711,11.2610852 C6.32215943,11.4089048 6.15565267,11.4837271 6.0008221,11.4354635 L3.22551831,10.5703504 C3.06290094,10.5196596 2.96820511,10.350765 3.00978727,10.1855836 L4.33308578,4.92889834 C4.35386243,4.84636495 4.40656906,4.77546278 4.47961453,4.73178454 L6.72830973,3.38715539 C6.78448244,3.35361757 6.84801543,3.33879392 6.91053769,3.34222149 C6.90953086,3.3215047 6.9085221,3.3007642 6.90751142,3.28 L9.40273013,2 C10.2740705,2.5 11.1398271,2.75 12,2.75 C12.8601729,2.75 13.7202401,2.5 14.5802017,2 L16.8912572,3.18552777 C16.96049,3.22094519 17.0129393,3.27936302 17.0415261,3.3484881 C17.11879,3.33240258 17.2010587,3.34498492 17.2716903,3.38715539 L19.5203855,4.73178454 C19.5934309,4.77546278 19.6461376,4.84636495 19.6669142,4.92889834 L20.9902127,10.1855836 C21.0317949,10.350765 20.9370991,10.5196596 20.7744817,10.5703504 L17.9991779,11.4354635 C17.8443473,11.4837271 17.6778406,11.4089048 17.6111229,11.2610852 L17.330799,10.64 C17.0371467,11.7490035 16.8198213,13.0245545 16.6788228,14.4666528 Z" id="basic-jersey" :style="{'fill': getColor(team.id, false)}"></path>
                      </svg>
                    </div>
                    <span>{{ team.name }}</span>
                  </label>
                </div>
              </div>
              
              <div v-else v-for="group in tournamentGroups" class="selectiongroup__item">
                <div class="selectiongroup__item__header">
                  {{ group.name }}
                </div>
                <div v-for="team in tournamentGroupTeams(group)" class="input-checkbox">
                  <input type="checkbox" :id="question.id + '_' + team.id" @change="teamChecked($event)" :checked="isTeamSelected(team.id)" />
                  <label :for="question.id + '_' + team.id">
                    <div class="team-logo">
                      <img v-if="teamCode(team.id) && teamCode(team.id).length > 6" :src="teamLogo(team.id)">
                      <flag v-else-if="teamCode(team.id) && teamCode(team.id).length <= 6" :iso="teamCode(team.id)" />
                      <svg v-else width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M16.6788228,14.4666528 C16.6784319,14.5535821 16.6782365,14.6380312 16.6782365,14.72 C16.6782365,17.92 17.0754204,17.92 17.0754204,22 L6.90751142,22 C6.90751142,18 7.30469536,18 7.30469536,14.72 C7.30469536,14.5820958 7.30416879,14.4377219 7.30311564,14.2868783 C7.16189664,12.9183228 6.95059177,11.7026967 6.66920105,10.64 L6.38887711,11.2610852 C6.32215943,11.4089048 6.15565267,11.4837271 6.0008221,11.4354635 L3.22551831,10.5703504 C3.06290094,10.5196596 2.96820511,10.350765 3.00978727,10.1855836 L4.33308578,4.92889834 C4.35386243,4.84636495 4.40656906,4.77546278 4.47961453,4.73178454 L6.72830973,3.38715539 C6.78448244,3.35361757 6.84801543,3.33879392 6.91053769,3.34222149 C6.90953086,3.3215047 6.9085221,3.3007642 6.90751142,3.28 L9.40273013,2 C10.2740705,2.5 11.1398271,2.75 12,2.75 C12.8601729,2.75 13.7202401,2.5 14.5802017,2 L16.8912572,3.18552777 C16.96049,3.22094519 17.0129393,3.27936302 17.0415261,3.3484881 C17.11879,3.33240258 17.2010587,3.34498492 17.2716903,3.38715539 L19.5203855,4.73178454 C19.5934309,4.77546278 19.6461376,4.84636495 19.6669142,4.92889834 L20.9902127,10.1855836 C21.0317949,10.350765 20.9370991,10.5196596 20.7744817,10.5703504 L17.9991779,11.4354635 C17.8443473,11.4837271 17.6778406,11.4089048 17.6111229,11.2610852 L17.330799,10.64 C17.0371467,11.7490035 16.8198213,13.0245545 16.6788228,14.4666528 Z" id="basic-jersey" :style="{'fill': getColor(team.id, false)}"></path>
                      </svg>
                    </div>
                    <span>{{ team.name }}</span>
                  </label>
                </div>
              </div>
  
              <div v-if="!this.expanded && isTournament() && groupCount > 1" @click="expandClicked" class="selectiongroup__expand">
                <img src="../assets/icons/ic_12_down_highlight.svg">{{ $t('special_questions.show_all_groups') }}
              </div>
              <div v-if="!this.expanded && (!isTournament() || groupCount < 2)" @click="expandClicked" class="selectiongroup__expand">
                <img src="../assets/icons/ic_12_down_highlight.svg">{{ $t('special_questions.show_all_teams') }}
              </div>
            </div>
          
            <multiselect :disabled="!isEditable" @input="singleChanged" v-else-if="question.answer_count === 1 && question.type === 'NUMBER'" v-model="value" :options="optionsNumber" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('please_select')"></multiselect>
    
            <multiselect :disabled="!isEditable" @input="singleChanged" v-else-if="question.answer_count === 1 && question.type === 'BOOL'" v-model="value" :options="optionsBool" track-by="name" label="name" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('please_select')">
                <template slot="singleLabel" slot-scope="{ option }">
                    <span v-if="option && option.val === 1">{{ $t('yes') }}</span>
                    <span v-else-if="option && option.val === 0">{{ $t('no') }}</span>
                    <span v-else></span>
                </template>
            </multiselect>
            
          <!--
            <multiselect :disabled="!isEditable" @input="singleChanged" v-else-if="question.answer_count === 1 && question.type === 'TEAM'" v-model="value" deselect-label="Can't remove this value" track-by="id" label="name" :show-labels="false" :placeholder="$t('please_select')" :options="options" :searchable="false" :allow-empty="true">
                <template slot="singleLabel" slot-scope="{ option }">{{ getTeamFullName(option.id, option.name) }}</template>
            </multiselect>
          -->

        </div>
        
        <div v-else @click="questionClicked(question)">
            <div v-if="question.answer_count === 1 && question.type !== 'TEAM'">
                <div class="table-view-cell" v-bind:class="{ bet_correct: correctAnswer, bet_wrong: wrongAnswer }">
                    <div class="table-view-cell-label">
                      {{ $t('special_questions.your_answer') }}
                    </div>
                    <div v-if="this.value && question.type === 'TEAM'" class="table-view-cell-value">
                        {{ this.value.name }}
                    </div>
                    <div v-else-if="question.type === 'NUMBER'" class="table-view-cell-value">
                        {{ this.value }}
                    </div>
                    <div v-else-if="question.type === 'BOOL' && this.value && this.value.val === 1" class="table-view-cell-value">
                      {{ $t('yes') }}
                    </div>
                    <div v-else-if="question.type === 'BOOL' && this.value && this.value.val === 0" class="table-view-cell-value">
                      {{ $t('no') }}
                    </div>
                </div>
                <div class="table-view-cell">
                    <div class="table-view-cell-label">
                      {{ $t('special_questions.solution') }}
                    </div>
                    <div v-if="solutions.length === 1 && question.type === 'TEAM'" class="table-view-cell-value">
                        {{ getTeamFullName(parseInt(solutions[0].solution), '') }}
                    </div>
                    <div v-else-if="solutions.length === 1 && question.type === 'NUMBER'" class="table-view-cell-value">
                        {{ solutions[0].solution }}
                    </div>
                    <div v-else-if="solutions.length === 1 && question.type === 'BOOL' && solutions[0].solution === '1'" class="table-view-cell-value">
                      {{ $t('yes') }}
                    </div>
                    <div v-else-if="solutions.length === 1 && question.type === 'BOOL' && solutions[0].solution === '0'" class="table-view-cell-value">
                      {{ $t('no') }}
                    </div>
                    <div v-else class="table-view-cell-value">
                      {{ $t('special_questions.solution_pending') }}
                    </div>
                    <!-- <div class="table-view-cell-drilldown"></div> -->
                </div>
            </div>
            <div v-if="question.answer_count > 0 && question.type === 'TEAM'">
                <div v-if="valuesSorted && valuesSorted.length > 0" v-for="val in valuesSorted" v-bind:class="{ bet_correct: val.correctAnswer, bet_wrong: val.wrongAnswer }" class="table-view-cell">
                    <div class="table-view-cell-label">
                      {{ $t('special_questions.your_answer') }}
                    </div>
                    <div class="table-view-cell-value">
                        {{ val.name }}
                    </div>
                </div>
                <div v-if="!valuesSorted || valuesSorted.length === 0" class="table-view-cell" v-bind:class="{ bet_wrong: solutionsSorted && solutionsSorted.length > 0 }">
                    <div class="table-view-cell-label">
                      {{ $t('special_questions.your_answer') }}
                    </div>
                    <div class="table-view-cell-value">
                    </div>
                    <!-- <div class="table-view-cell-drilldown"></div> -->
                </div>
                <div v-if="solutionsSorted && solutionsSorted.length > 0" v-for="sol in solutionsSorted" class="table-view-cell">
                    <div class="table-view-cell-label">
                      {{ $t('special_questions.solution') }}
                    </div>
                    <div class="table-view-cell-value">
                      {{ getTeamFullName(parseInt(sol.solution), '') }}
                    </div>
                    <!-- <div class="table-view-cell-drilldown"></div> -->
                </div>
                <div v-if="!solutionsSorted || solutionsSorted.length === 0" class="table-view-cell">
                  <div class="table-view-cell-label">
                    {{ $t('special_questions.solution') }}
                  </div>
                  <div class="table-view-cell-value">
                    {{ $t('special_questions.solution_pending') }}
                  </div>
                  <!-- <div class="table-view-cell-drilldown"></div> -->
                </div>
            </div>
        </div>
        
        <div v-if="!questionEditable">
          <button v-on:click="questionClicked(question)" style="margin-top: 8px; margin-bottom: 8px;">{{ $t('special_questions.show_answers') }}</button>
        </div>  
      </div>

    </div>
</template>

<script>
  
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import Vue from 'vue'
  
  export default {
    name: 'SpecialQuestion',
    props: {
      question: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        value: null,
        values: [],
        answerSaved: false,
        expanded: false
      }
    },
    created () {
      const answers = this.$store.state.answers.filter(s => s.fk_question === this.question.id)
      if(this.question.answer_count === 1) {
        if(this.question.type === 'NUMBER' && answers[0]) {
          this.value = parseInt(answers[0].answer)
        } else if(this.question.type === 'TEAM' && answers[0]) {
          //this.value = this.question.optionsJSON.filter(s => s.id === parseInt(answers[0].answer))[0]
          var temp = []
          for(var i=0; i<answers.length; i++) {
            const val = answers[i]
            const v = this.question.optionsJSON.filter(s => s.id === parseInt(val.answer))[0]
            if(v) {
              temp.push(v)
            } else {
              temp.push({"id":0,"name":this.$i18n.t('special_questions.invalid_selection')})
            }
          }
          this.values = temp
        } else if(this.question.type === 'BOOL' && answers[0]) {
          if(parseInt(answers[0].answer) === 0) {
            this.value = { name: this.$i18n.t('no'), val: 0 }
          } else if(parseInt(answers[0].answer) === 1) {
            this.value = { name: this.$i18n.t('yes'), val: 1 }
          }
        } else {
          this.value = null
        }
      } else if(this.question.answer_count > 1){
        var temp = []
        for(var i=0; i<answers.length; i++) {
          const val = answers[i]
          const v = this.question.optionsJSON.filter(s => s.id === parseInt(val.answer))[0]
          temp.push(v)
        }
        this.values = temp
      }
    },
    mounted () {

    },
    computed: {
      groupCount () {
        return this.$store.state.tournamentGroups ? this.$store.state.tournamentGroups.length : 0
      },
      tournamentGroups () {
        return this.expanded ? this.$store.state.tournamentGroups : [this.$store.state.tournamentGroups[0]]
      },
      pointsAchieved() {
        var points = 0
        if(this.question.type === 'NUMBER' && this.question.answer_count === 1 && this.solutions.length === 1) {
          points = this.value === parseInt(this.solutions[0].solution) ? this.question.points : 0
        } else if(this.value && this.question.type === 'BOOL' && this.question.answer_count === 1 && this.solutions.length === 1) {
          points = this.value.val === parseInt(this.solutions[0].solution) ? this.question.points : 0
        } else if(this.question.type === 'TEAM' && this.solutions.length > 0) {
          for(var i=0; i<this.valuesSorted.length; i++) {
            if(this.valuesSorted[i].correctAnswer) {
              points += this.question.points
            }
          }
        }
        return points
      },
      questionTotalPoints() {
        return this.question.points * this.question.answer_count
      },
      valuesSorted() {
        var temp = this.values.sort(function(a,b){
          var x = a.name < b.name? -1:1
          return x
        })
        for(var i=0; i<temp.length; i++) {
          temp[i].correctAnswer = this.solutions.length > 0 && this.solutions.filter(s => parseInt(s.solution) === temp[i].id).length > 0
          temp[i].wrongAnswer = this.solutions.length > 0 && !temp[i].correctAnswer
        }
        return temp
      },
      solutionsSorted() {
        return this.solutions
      },
      correctAnswer() {
        if(this.parseMatchdate(this.question.editable_until) > Date.now()) {
          return false
        }
        if(this.solutions.length === 0) {
          return false
        }
        if(this.question.type === 'NUMBER' && this.question.answer_count === 1 && this.solutions.length === 1) {
          return this.value === parseInt(this.solutions[0].solution)
        } else if(this.question.type === 'BOOL' && this.question.answer_count === 1 && this.solutions.length === 1) {
          if(this.value) {
            return this.value.val === parseInt(this.solutions[0].solution)
          } else {
            return false
          }
        } else if(this.question.type === 'TEAM' && this.solutions.length > 0) {
          for(var i=0; i<this.values.length; i++) {
            const aid = this.values[i].id
            var found = false
            for(var j=0; j<this.solutions.length; j++) {
              if(aid === parseInt(this.solutions[j].solution)) {
                found = true
                break
              }
            }
            if(!found) {
              return false
            }
          }
        }
        return true
      },
      wrongAnswer() {
        if(this.parseMatchdate(this.question.editable_until) > Date.now()) {
          return false
        }
        if(this.solutions.length === 0) {
          return false
        }
        if(this.question.type === 'NUMBER' && this.question.answer_count === 1 && this.solutions.length === 1) {
          return this.value !== parseInt(this.solutions[0].solution)
        } else if(this.question.type === 'BOOL' && this.question.answer_count === 1 && this.solutions.length === 1) {
          if(this.value) {
            return this.value.val !== parseInt(this.solutions[0].solution)
          } else {
            return true
          }
        } else if(this.question.type === 'TEAM' && this.solutions.length > 0) {
          for(var i=0; i<this.values.length; i++) {
            const aid = this.values[i].id
            var found = false
            for(var j=0; j<this.solutions.length; j++) {
              if(aid === parseInt(this.solutions[j].solution)) {
                found = true
                break
              }
            }
            if(!found) {
              return true
            }
          }
        }
        return false
      },
      isEditable() {
        return this.solutions.length === 0 && this.parseMatchdate(this.question.editable_until) > Date.now()
      },
      options() {
        if(this.expanded) {
          return this.question.optionsJSON !== undefined && this.question.optionsJSON !== null ? this.question.optionsJSON : [] 
        } else {
          return this.question.optionsJSON !== undefined && this.question.optionsJSON !== null ? this.question.optionsJSON.slice(0, 4) : []
        }
      },
      optionsBool() {
        return [
          { name: this.$i18n.t('yes'), val: 1 },
          { name: this.$i18n.t('no'), val: 0 }
        ]
      },
      optionsNumber() {
        const o = this.question.options
        const minmax = o.trim().split(',')
        if(minmax.length === 2) {
          const min = parseInt(minmax[0]) < parseInt(minmax[1]) ? parseInt(minmax[0]) : parseInt(minmax[1])
          const max = parseInt(minmax[0]) < parseInt(minmax[1]) ? parseInt(minmax[1]) : parseInt(minmax[0])
          var result = [max-min]
          if(min !== max) {
            for (var i = min, c = 0; i <= max; i++, c++) {
              result[c] = i;
            }
          }
          return result
        }
        return  []
      },
      solutions () {
        return this.$store.state.solutions.filter(s => s.fk_question === this.question.id)
      },
      questionEditable() {
        return this.question && this.parseMatchdate(this.question.editable_until) > Date.now()
      }
    },
    methods: {
      tournamentGroupTeams (group) {
        var teams = []
        const temp = this.$store.state.tournamentGroupTables.filter(t => t.fk_tournament_group === group.id)
        const limit = this.expanded ? temp.length : 4
        for(var i=0; i<temp.length && i<limit; i++) {
          teams.push({id: temp[i].fk_team, name: temp[i].teamname})
        }
        return teams
      },
      isTeamSelected(id) {
        const answers = this.$store.state.answers.filter(s => s.fk_question === this.question.id)
        for (var i = 0; i < answers.length; i++) {
          if('' + id === '' + answers[i].answer) {
            return true
          }
        }
        return false
      },
      teamChecked(event) {
        if(event.target.checked) {
          if(this.question.answer_count === 1) {
            if(this.values.length > 0) {
              for(var i=0; i<this.values.length; i++) {
                const e = document.getElementById(this.question.id + '_' + this.values[i].id) 
                if(e) {
                  e.checked = false
                }
              }
            }
            const id = event.target.id.split('_')[1]
            this.values = [{id: id}]
          } else if(this.question.answer_count > 1) {
            if(this.values.length < this.question.answer_count) {
              const id = event.target.id.split('_')[1]
              this.values.push({id: id})
            } else {
              const first = this.values.shift()
              const e = document.getElementById(this.question.id + '_' + first.id)
              if(e) {
                e.checked = false
              }
              const id = event.target.id.split('_')[1]
              this.values.push({id: id})
            }
          } 
        } else if(!event.target.checked) {
          if(this.question.answer_count === 1) {
            this.values = []
          } else if(this.question.answer_count > 1) {
            for(var i=0; i<this.values.length; i++) {
              this.values = this.values.filter(function (element) {
                return '' + element.id !== '' + event.target.id.split('_')[1]
              })
            }
          }
        }
        this.multiChanged()
      },
      expandClicked() {
        this.expanded = !this.expanded
        if(this.expanded) {
          if(this.question.type === 'TEAM' && this.$store.state.answers && this.question) {
            const answers = this.$store.state.answers.filter(s => s.fk_question === this.question.id)
            for (var i = 0; i < answers.length; i++) {
              const e = document.getElementById(this.question.id + '_' + answers[i].answer)
              if (e) {
                e.checked = true
              }
            }
          }
        }
      },
      teamLogo(team) {
        const l = this.getTeamLogo(team)
        if(l) {
          return this.getBGValue('spmau') + '/images/jerseys/72/' + l
        }
        return null
      },
      teamCode(team) {
        const l = this.getTeamLogo(team)
        if(l) {
          return l
        }
        return null
      },
      questionClicked(q) {
        if(this.parseMatchdate(q.editable_until) < Date.now()) {
          this.$router.push({ name: 'specialquestiondetail', params: { question: q } })
        }
      },
      multiChanged() {
        //if(this.values.length !== this.question.answer_count) {
        //  return
        //}
        var answers = []
        for(var i=0; i<this.values.length; i++) {
          const val = this.values[i]
          answers.push({
            'fk_user': this.$store.state.user.id,
            'fk_question': this.question.id,
            'answer': parseInt(val.id),
            'fk_betgame': parseInt(this.$store.state.betgameId)
          })
        }
        const that = this
        if(answers.length > 0) {
          this.$store.dispatch('updateAnswer', answers).then(response => {
            Vue.$log.debug('SpecialQuestion multiChanged updateAnswer ok')
            this.answerSaved = true
            this.$store.dispatch('fetchUserAnswers', []).then(function (response) {
            })
          }, error => {
            Vue.$log.debug(error.toString())
            that.value = null
            that.values = []
            alert(that.$i18n.t('special_questions.save_answer_error'))
          })
        } else {
          const d = {
            'fk_user': this.$store.state.user.id,
            'fk_question': this.question.id,
            'fk_betgame': parseInt(this.$store.state.betgameId)
          }
          this.$store.dispatch('deleteAnswer', d).then(function (response) {
            this.answerSaved = true
            this.$store.dispatch('fetchUserAnswers', []).then(function (response) {
            })
          })
        }
      },
      singleChanged() {
        var a = this.value.id
        if(this.question.type === 'NUMBER') {
          a = this.value
        } else if(this.value && this.question.type === 'BOOL') {
          a = this.value.val
        }
        const answer = {
          'fk_user': this.$store.state.user.id,
          'fk_question': this.question.id,
          'answer': parseInt(a),
          'fk_betgame': parseInt(this.$store.state.betgameId)
        }
        const that = this
        this.$store.dispatch('updateAnswer', answer).then(response => {
          Vue.$log.debug('SpecialQuestion singleChanged updateAnswer ok')
          this.answerSaved = true
          this.$store.dispatch('fetchUserAnswers', []).then(function (response) {
          })
        }, error => {
          Vue.$log.debug(error.toString())
          that.value = null
          that.values = []
          alert(that.$i18n.t('special_questions.save_answer_error'))
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .list {
        position: relative;
        padding: 4px 16px;
        margin-bottom: 24px;
    }
    
    .table-view-header-small {
        display: flex;
        flex-direction: column;
        margin-bottom: 0px;
        display: flex;
        flex-direction: row;
        font-size: 12px;
        font-weight: 300;
        color: $colorGreyMid;
        padding: 8px 0 0px;
        border-bottom: none;
    }

    .table-view-cell:last-child {
      border-bottom: 0;
    }

    .table-view-cell {
      position: relative;

      &-label, &-value {
        position: relative;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: -16px;
        width: calc(100% + 32px);
        height: calc(100% + 1px);
      }

      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        background: rgba($colorGreyLight, .08);
        width: 100%;
        height: 1px;
        opacity: 0
      }
    }

    .bet_correct {
      &:before {
        background: #EEFDF5;
      }
      &:after {
        opacity: 1;
      }
    }

    .bet_wrong {
      &:before {
        background: #FFF1F0;
      }
      &:after {
        opacity: 1;
      }
    }

    .specialquestion-header {
      display: flex;
      font-size: 14px;
      color: $colorGreyMid;
      margin: -3px 0 8px;

      &-left {
        margin-right: auto;
      }
    }

    .question_answered {
      position: relative;

      &:after {
        z-index: 2;
        content: 'Gespeichert';
        position: absolute;
        left: 2px;
        bottom: -2px;
        color: $colorPositive;
        padding-left: 8px;
        font-size: 10px;
        background: url(../assets/icons/ic_bet_saved.svg) no-repeat;
        background-position: left;
      }
    }

    .input-checkbox {
      label {
        display: flex;
        align-items: center;
        padding: 12px 24px 12px 0;

        .team-logo, img, svg, .flag {
          width: 20px;
          height: 20px;
          margin-right: 12px;

          span {
            display: flex;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            box-shadow: inset 0 0 0 1px rgba(0,0,0,0.08);
          }
        }
      }
    }

    .selectiongroup {

      &__item {

        &__header {
          font-size: 12px;
          font-weight: 500;
          margin: 12px 0 8px;
        }

      }
      &__expand {
        display: flex;
        justify-content: center;
        color: var(--color-primary);
        padding: 10px 16px 12px;
        font-weight: 500;
        margin-top: 8px;
        cursor: pointer;

        img {
          margin-right: 8px;
        }
      }
    }
</style>
